import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFiltersPR } from '../../../components/providers/FiltersProvider';
import { FilterDrawerView } from '../../../components/table/components/TableFilter';
import { RootState } from '../../../redux/store';
import StatesFilters from './StatesFilters';
import FilteredStatesTable from './components/FilteredStatesTable';
import StatesListLayout from './components/StatesListLayout';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import ErrorPage from '../../../components/error/ErrorPage';

const StatesList = () => {

    // HOOKS

    const location = useLocation();
    const navigate = useNavigate();
    const { userCan } = usePrivilege();
    const { selectedView } = useSelector((state: RootState) => state.states);
    const { filters, updateFilters, updateFilterOrder, updatePage, updatePageSize, resetFilters } = useFiltersPR();

    // STATES

    const [entity, setEntity] = useState<string>('');
    const [openFilters, setOpenFilters] = useState<boolean>(false);

    /**
     * Redirect to the selected view after the page is loaded
     */
    useEffect(() => {
        if (location.pathname === '/states') {
            setTimeout(() => {
                navigate(`/states${selectedView}`);
            }, 100);
        }
    }, []);

    /**
     * Reset filters when the view changes
     */
    useEffect(() => {
        resetFilters();
    }, [selectedView]);

    /**
     * Update filters when the location changes, getting the entity from the URL
     */
    useEffect(() => {
        const entityName = location.pathname.replace('/states/', '').replace('_states', '');
        setEntity(entityName);
        updateFilters({ entity: entityName });
    }, [location.pathname]);

    return (
        <StatesListLayout>
            {entity && userCan( 'list_statuses', 'statuses' ) ? (
                <FilteredStatesTable
                    entity={entity}
                    filters={filters} updateFilters={updateFilters} updateFilterOrder={updateFilterOrder} updatePage={updatePage} updatePageSize={updatePageSize}
                    openFilters={openFilters} setOpenFilters={setOpenFilters}
                />
            ) : <ErrorPage /> }

            <FilterDrawerView isOpen={openFilters} setOpenDrawer={setOpenFilters} drawerTitle={'Filtros Estados'}>
                <StatesFilters filters={filters} updateFilters={updateFilters} resetFilters={resetFilters} />
            </FilterDrawerView>
        </StatesListLayout>
    );
};

export default StatesList;